export type PageSections = 'card' | 'qr-code' | 'email-signature';
export enum PageModes {
  View = 'view',
  Edit = 'edit',
  Create = 'create',
}

export type PageSection = `${PageSections}`;
export type PageMode = `${PageModes}`;

export type CardPageRouteInfo =
  | { pageMode: 'edit'; tab: PageSection; params: { id: string } }
  | { pageMode: 'view'; tab: PageSection; params: { id: string | undefined } }
  | { pageMode: 'create'; tab: PageSection; params: { id: undefined; from: string | undefined } }
  | { pageMode: 'invalid'; tab: undefined; params: { id: undefined } }
  | undefined;
